export enum RecognitionStatus {
  Pending = 0,
  Approved = 1,
  ApproveWithConditions = 2,
  Rejected = 3,
  Withdrawn = 4,
}
